import { NgModule } from '@angular/core';
import { UserLocaleNumberPipe } from './user-locale-number.pipe';
import { UserGBDELocaleNumberPipe } from './user-gbde-locale-number.pipe';
import { LocaleNumberModule } from '../locale-number/locale-number.module';
import { LocaleNumberPipe } from '../locale-number/locale-number.pipe';

@NgModule({
  imports: [LocaleNumberModule],
  declarations: [UserLocaleNumberPipe, UserGBDELocaleNumberPipe],
  providers: [LocaleNumberPipe],
  exports: [UserLocaleNumberPipe, UserGBDELocaleNumberPipe, LocaleNumberModule],
})
export class UserLocaleNumberModule {
}
